import { useSelector } from 'react-redux'
import * as Actions from 'actions'
import { SOURCE_FILE_TYPES } from 'enums'
import { selectMediaRecordingSettingsState } from 'selectors/recording'
import { useAction } from 'hooks/utils'
import { selectShowAssetSettingsType } from 'selectors/mainView'
import { getEditingAsset } from './helpers/getEditingAsset'

/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
type UpdateAssetFuncType = (...args: any[]) => void

export const useMediaAssetSettingsForm = () => {
  const mediaRecordingOpened = useSelector(selectMediaRecordingSettingsState)
  const showAssetSettingsType = useSelector(selectShowAssetSettingsType)
  const sourceFileType = Object.values(SOURCE_FILE_TYPES).find(fType => fType === showAssetSettingsType)
  const asset = useSelector(state => getEditingAsset(state, sourceFileType))
  const showSettings = (asset !== null) && !mediaRecordingOpened

  const onUpdateAsset = useAction(Actions.layer.updateEditingAsset, sourceFileType) as UpdateAssetFuncType

  return {
    showSettings,
    onUpdateAsset,
    asset,
    type: showAssetSettingsType || '',
  }
}
